import { createSelector } from "reselect";

export const selectUI = (state) => state.UI;

export const selectLoading = createSelector([selectUI], (UI) => UI.loading);

export const selectTheme = createSelector([selectUI], (UI) => UI.theme);

export const selectShowChat = createSelector([selectUI], (UI) => UI.show_chat);
